import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, ShieldCheck, AlertCircle } from "lucide-react";
import { api } from "../lib/api";

export default function VerifyCertificate() {
  const { certId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/certificates/verify/${certId}`)
      .then(r => setData(r.data))
      .catch(e => console.error(e))
      .finally(() => setLoading(false));
  }, [certId]);

  return (
    <div className="min-h-screen bg-fc-navy text-white flex items-center justify-center px-6" data-testid="verify-certificate-page">
      <div className="max-w-xl w-full bg-[#060A24] border border-white/10 p-10 text-center">
        <Link to="/" className="inline-flex items-center gap-3 mb-8 justify-center">
          <img src="/brand/freddy-symbol.webp" alt="Freddy" className="h-9 w-auto" />
          <span className="text-white font-black tracking-[0.18em] text-xs">FREDDY COMPUTE ACADEMY</span>
        </Link>
        {loading ? (
          <p className="text-white/55">Verifying…</p>
        ) : !data?.valid ? (
          <>
            <AlertCircle className="mx-auto text-fc-red mb-4" size={48} />
            <h1 className="fc-h-section text-2xl mb-3">Certificate not found</h1>
            <p className="text-white/65 text-sm">The certificate ID you used does not match an issued certificate.</p>
          </>
        ) : (
          <>
            <ShieldCheck className="mx-auto text-[#10B981] mb-4" size={48} />
            <h1 className="fc-h-section text-2xl mb-3">Verified</h1>
            <p className="text-white/55 text-xs tracking-[0.18em] uppercase mb-6">This certificate is genuine</p>

            <div className="bg-fc-navy border border-white/10 p-6 text-left space-y-4">
              <div>
                <p className="fc-overline mb-1 text-[10px]">PUBLIC ALIAS</p>
                <p className="font-mono text-fc-red font-bold text-lg" data-testid="verify-alias">{data.student_alias}</p>
              </div>
              <div>
                <p className="fc-overline mb-1 text-[10px]">COURSE</p>
                <p className="font-black text-lg" data-testid="verify-course">{data.course_title}</p>
              </div>
              <div>
                <p className="fc-overline mb-1 text-[10px]">INSTRUCTOR</p>
                <p className="text-white/85">{data.instructor_name}</p>
              </div>
              <div>
                <p className="fc-overline mb-1 text-[10px]">COMPLETED</p>
                <p className="text-white/85">{data.completed_at ? new Date(data.completed_at).toLocaleDateString() : "—"}</p>
              </div>
              <div>
                <p className="fc-overline mb-1 text-[10px]">CERTIFICATE ID</p>
                <p className="font-mono text-white/55 text-xs break-all">{data.certificate_id}</p>
              </div>
            </div>

            <p className="text-white/40 text-xs mt-6">For privacy, real names are not displayed on public verification.</p>
          </>
        )}
      </div>
    </div>
  );
}
